var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-slide-list',{attrs:{"items":_vm.value,"sort-by":"price","width":"200"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('gun-box',{key:item._id,attrs:{"value":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }